<button
  class="btn user-menu__trigger"
  type="button"
  [attr.aria-expanded]="isOpen()"
  aria-haspopup="menu"
  aria-label="Account menu"
  (click)="toggle()"
>
  <span class="avatar avatar--sm" aria-hidden="true">{{ initials() }}</span>
  <span class="user-menu__name truncate">{{ fullName() }}</span>
  <i class="ph ph-caret-down btn__caret" aria-hidden="true"></i>
</button>

@if (isOpen()) {
  <div class="menu popover__panel" role="menu">
    <div class="popover__header">
      <p class="popover__name truncate">{{ fullName() }}</p>
      <p class="popover__meta truncate">{{ user()?.emailAddress }}</p>
    </div>

    <a class="menu__item" role="menuitem" routerLink="/a/profile" (click)="close()">
      <i class="ph ph-user-circle" aria-hidden="true"></i>
      <span>My profile</span>
    </a>
    <a class="menu__item" role="menuitem" routerLink="/a/configuration" (click)="close()">
      <i class="ph ph-gear-six" aria-hidden="true"></i>
      <span>Configuration</span>
    </a>

    <div class="menu__separator" role="separator"></div>

    <div class="popover__row">
      <span id="theme-label">Theme</span>
      <div class="theme-toggle" role="group" aria-labelledby="theme-label">
        @for (option of themeOptions; track option.value) {
          <button
            class="theme-toggle__option"
            type="button"
            [attr.aria-pressed]="themeService.getTheme() === option.value"
            [attr.aria-label]="option.label + ' theme'"
            [title]="option.label"
            (click)="setTheme(option.value)"
          >
            <i class="ph ph-{{ option.icon }}" aria-hidden="true"></i>
          </button>
        }
      </div>
    </div>

    <div class="menu__separator" role="separator"></div>

    <button class="menu__item menu__item--danger" type="button" role="menuitem" (click)="signOut()">
      <i class="ph ph-sign-out" aria-hidden="true"></i>
      <span>Sign out</span>
    </button>
  </div>
}
